import { useCallback } from 'react';
import { useLazyGetEmbedSsoUrlQuery } from '@/store/api';
/**
 * Platform-services lazy-query hook for fetching an analytics embed SSO URL on demand.
 *
 * @see src/store/api/cc/analyticsApi.ts
 */
export const useLazyGetEmbedSsoUrl = () => {
    const [trigger, { data, isLoading, isFetching, isError, error, }] = useLazyGetEmbedSsoUrlQuery();
    const triggerGetEmbedSsoUrl = useCallback((params) => trigger(params).unwrap(), [trigger]);
    return {
        triggerGetEmbedSsoUrl,
        data,
        isLoading: isLoading || isFetching,
        isError,
        error,
    };
};
